import Toast from '@salesforce/design-system-react/components/toast';
import ToastContainer from '@salesforce/design-system-react/components/toast/container';
// import { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../app/hooks';
import { getToasts, removeToast } from './ToastsSlice';

const GenericToast = () => {
  const dispatch = useAppDispatch();
  const toasts = useAppSelector(getToasts);

  // const [isOpen, setIsOpen] = useState(false);
  // const [msg, setMsg] = useState('This is a Toast Msg !');
  // const [type, setType] = useState<'error' | 'warning'>('warning');
  // const [duration, setDuration] = useState<number>();

  // const triggerToast = (msg:string, type:'error' | 'warning', duration:number ) => {
  //   setMsg(msg);
  //   setType(type);
  //   setDuration(duration);
  //   setIsOpen(true);
  // }

  return (
    <>
      <ToastContainer className="slds-grid slds-grid_vertical slds-grid_vertical-align-center">
        {/* <Toast
          labels={{
            heading: 'blabla'
          }}
          variant="success"
        /> */}
        {toasts.map((toast) => {
          return (
            <Toast
              labels={{
                heading: toast.msg
              }}
              variant={toast.type}
              duration={toast.duration}
              onRequestClose={() => dispatch(removeToast({ id: toast.id }))}
            />
          );
        })}
      </ToastContainer>
    </>
  );
};

export default GenericToast;
